export { default as XRayAnalysis } from "./XRayAnalysis";
export * from "./XRayAnalysis";
